"use client";

import { useState } from "react";

interface Video {
  id: string;
  title: string;
  url: string;
  thumbnail: string;
}

const videos: Video[] = [
  {
    id: "wyUCWzGl7gY",
    title: "Welcome to La Plage Meta Verse",
    url: "https://youtu.be/wyUCWzGl7gY",
    thumbnail: "https://img.youtube.com/vi/wyUCWzGl7gY/maxresdefault.jpg",
  },
  {
    id: "CUMZ_0Ce8Tg",
    title: "Why you need to study Data Processing with La Plage Meta Verse",
    url: "https://youtu.be/CUMZ_0Ce8Tg",
    thumbnail: "https://img.youtube.com/vi/CUMZ_0Ce8Tg/maxresdefault.jpg",
  },
  {
    id: "qPh8RUl3bes",
    title: "Introduction to special needs caregiving",
    url: "https://youtu.be/qPh8RUl3bes",
    thumbnail: "https://img.youtube.com/vi/qPh8RUl3bes/maxresdefault.jpg",
  },
  {
    id: "XuxjRHizfdE",
    title: "Introduction to Microsoft Power BI",
    url: "https://youtu.be/XuxjRHizfdE",
    thumbnail: "https://img.youtube.com/vi/XuxjRHizfdE/maxresdefault.jpg",
  },
  {
    id: "-eToCDmaBXw",
    title: "Introduction to Project Data Representation",
    url: "https://youtu.be/-eToCDmaBXw",
    thumbnail: "https://img.youtube.com/vi/-eToCDmaBXw/maxresdefault.jpg",
  },
];

export function VideoGallery() {
  const [selectedVideo, setSelectedVideo] = useState<Video | null>(null);
  const [playMode, setPlayMode] = useState<"embed" | "redirect">("embed");

  const handleVideoClick = (video: Video, mode: "embed" | "redirect") => {
    if (mode === "redirect") {
      window.open(video.url, "_blank");
    } else {
      setSelectedVideo(video);
      setPlayMode(mode);
    }
  };

  const closeModal = () => {
    setSelectedVideo(null);
  };

  return (
    <>
      <div className=" w-full   px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 place-content-center items-center">
            {videos.map((video) => (
              <div
                key={video.id}
                className="group cursor-pointer transition-all duration-300 hover:scale-105"
              >
                <div className="relative w-full aspect-video overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300">
                  <img
                    src={video.thumbnail || "/placeholder.svg"}
                    alt={video.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-[#21205A]/90 via-black/30 to-[#21205A]/0" />

                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <h3
                      className="text-[#FFF] font-bold text-sm leading-tight line-clamp-2 mb-3"
                      style={{
                        textShadow:
                          "2px 2px 4px rgba(0,0,0,0.8), 0px 0px 8px rgba(0,0,0,0.6)",
                      }}
                    >
                      {video.title}
                    </h3>
                  </div>

                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="flex gap-3">
                      <button
                        onClick={() => handleVideoClick(video, "embed")}
                        className="px-4 py-2 bg-[#FFF]/95 text-black hover:bg-[#FFF] rounded-full transition-all duration-200 flex items-center text-sm font-semibold shadow-lg hover:shadow-xl transform hover:scale-105"
                      >
                        <svg
                          className="w-4 h-4 mr-2"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8 5v14l11-7z" />
                        </svg>
                        Play
                      </button>
                      <button
                        onClick={() => handleVideoClick(video, "redirect")}
                        className="px-4 py-2 bg-[#ee1717] text-[#FFF] hover:bg-[#ee1717]/80 rounded-full transition-all duration-200 flex items-center text-sm font-semibold shadow-lg hover:shadow-xl transform hover:scale-105"
                      >
                        <svg
                          className="w-4 h-4 mr-2"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                        </svg>
                        YouTube
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {selectedVideo && (
        <div className="fixed inset-0 bg-[#111]/80 z-50 flex items-center justify-center p-4">
          <div className="bg-[#FFF] rounded-lg w-full max-w-4xl max-h-[90vh] overflow-hidden">
            <div className="flex items-center justify-between p-4 border-b border-[#eee]">
              <h2 className="text-lg font-semibold text-gray-900  line-clamp-1">
                {selectedVideo.title}
              </h2>
              <button
                onClick={closeModal}
                className="shrink-0 p-1 hover:bg-[#eee] rounded-md transition-colors duration-200"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12m0-6L10 14"
                  />
                </svg>
              </button>
            </div>
            <div className="aspect-video">
              <iframe
                src={`https://www.youtube.com/embed/${selectedVideo.id}?autoplay=1`}
                title={selectedVideo.title}
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div className="p-4 border-t border-[#eee]">
              <button
                onClick={() => window.open(selectedVideo.url, "_blank")}
                className="w-full px-4 py-2 border border-[#eee] text-gray-700 hover:bg-gray-50 rounded-md transition-colors duration-200 flex items-center justify-center"
              >
                <svg
                  className="w-4 h-4 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                  />
                </svg>
                Watch on YouTube
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
